var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoresTrendingDownward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #823df5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    className: "cls-1",
    d: "M25.15,10.2c-.77,0-1.4.63-1.4,1.4v1.35l-6.98-6.87c-.26-.26-.61-.41-.97-.43-.38,0-.73.16-.99.44l-3.14,3.33L7.55,3.69c-.52-.57-1.4-.62-1.98-.1-.49.45-.6,1.18-.26,1.75l5.08,7.07h0c.45.63,1.33.77,1.96.31.07-.05.14-.11.2-.17l3.27-3.51,5.89,5.82h-1.24c-.77-.05-1.43.54-1.48,1.31s.54,1.43,1.31,1.48c.06,0,.11,0,.17,0h4.67c.77,0,1.4-.63,1.4-1.4v-4.66c0-.77-.63-1.4-1.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    className: "cls-1",
    d: "M23.28,21.65c-1.03,0-1.87.84-1.87,1.87h0v3.74h6.54v-3.74c0-1.03-.84-1.87-1.87-1.87h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    className: "cls-1",
    d: "M14.4,17.92c-1.03,0-1.87.84-1.87,1.87,0,0,0,0,0,0v7.48h6.54v-7.48c0-1.03-.84-1.87-1.87-1.87h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    className: "cls-1",
    d: "M10.2,16.05c0-1.03-.84-1.87-1.87-1.87h-2.8c-1.03,0-1.87.83-1.87,1.86,0,0,0,0,0,0v11.21h6.54v-11.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoresTrendingDownward);
export default __webpack_public_path__ + "static/media/Scores Trending Downward.9131ef92d73e716d17bcd0698d5fca2c.svg";
export { ForwardRef as ReactComponent };